import { PaginatedApiResponse } from "@/types/api.types";
import baseApi from "./RootBaseApi";
import { CommunityUsersPaginatedResponse } from "@/types/user-management.types";

export interface CommunityUsersQueryParams {
  search?: string;
  page?: number;
  limit?: number;
}

export const CommunityUsers = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all community users
    getCommunityUser: builder.query<
      PaginatedApiResponse<CommunityUsersPaginatedResponse>,
      CommunityUsersQueryParams | void
    >({
      query: (params) => ({
        url: `/user-management/community-users`,
        method: "GET",
        params: params
          ? {
              search: params.search,
              page: params.page,
              limit: params.limit,
            }
          : {},
        headers: {
          "x-lang": "en",
        },
      }),
      providesTags: [{ type: "Communities", id: "LIST" }],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetCommunityUserQuery } = CommunityUsers;
